<form [formGroup]="form" (ngSubmit)="submitForm()" novalidate>
  <title mat-dialog-title>{{ 'account.dialogs.changeEmail.title' | t }}</title>
  <mat-dialog-content class="fixed-size-dialog">
    <p>{{ 'account.dialogs.changeEmail.description' | t }}</p>
    
    <p class="password-notice">{{ 'account.dialogs.changeEmail.passwordNotice' | t }}</p>

    <mat-error *ngIf="errorMessage" class="error-container">
      <span>{{ errorMessage }}</span>
    </mat-error>

    <sn-form [form]="form" [fields]="formFields" [(model)]="formModel"></sn-form>

    <p class="important-note">
      <b>{{ 'account.dialogs.changeEmail.importantNote' | t }}</b><br />
      {{ 'account.dialogs.changeEmail.importantNoteText' | t }}
    </p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button type="button" color="danger" (click)="cancel()">{{ 'common.cancel' | t }}</button>
    <button
      mat-button
      type="submit"
      color="success"
      [disabled]="form.invalid || !formModel.password"
      [mtBasicSpinner]="isLoading"
    >
      {{ 'common.update' | t }}
    </button>
  </mat-dialog-actions>
</form>
